export default {
  packRefinement: { completePattern: '패턴·치수 완료', patternDone: '패턴·치수 완료됨' },
  app: {
    name: 'Design Sheet',
    shortName: 'Design Sheet',
    wordmarkDesign: 'design',
    wordmarkSheet: 'sheet',
    company: 'E·LAND China',
  },

  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    saved: '저장되었습니다',
    deleted: '삭제됨',
    saveDraft: '임시저장',
    submit: '제출',
    delete: '삭제',
    edit: '수정',
    detail: '상세',
    expandDetails: '상세 펼치기',
    collapseDetails: '상세 접기',
    search: '조회',
    select: '선택',
    reset: '초기화',
    export: '내보내기',
    back: '뒤로',
    loading: '불러오는 중…',
    refresh: '새로고침',
    noData: '데이터 없음',
    total: '총 {n} 건',
    operation: '작업',
    createdAt: '생성일시',
    updatedAt: '수정일시',
    createdBy: '생성자',
    yes: '예',
    no: '아니오',
    language: '언어',
  },

  auth: {
    homeHeadlineFirst: '디자인 시안에서,',
    homeHeadlineLast: '테크팩까지.',
    homeDescription: '스타일 자료를 정리하고 원부자재·패턴·치수를 함께 완성하여 생산에 전달합니다.',
    homeHeroAlt: '마네킹, 원단과 디자인 스케치가 놓인 의상 디자인 스튜디오',
    homeFeaturesLabel: '주요 업무',
    homeDesignTitle: '디자인 자료',
    homeDesignDescription: '시안을 가져오고 스타일 정보를 정리합니다.',
    homeCollaborateTitle: '협업 입력',
    homeCollaborateDescription: '원부자재와 패턴·치수를 함께 완성합니다.',
    homeTechPackTitle: '테크팩',
    homeTechPackDescription: '자료를 확인하고 미리보기·내보내기를 진행합니다.',
    loginHelp: '로그인 도움말',
    homeNavigation: '홈 내비게이션',
    homeCopyright: '© 2026 E·LAND GROUP. All Rights Reserved.',
    loginHelpScanTitle: '기업 위챗 로그인',
    loginHelpScanDescription: '기업 위챗으로 이 페이지의 QR 코드를 스캔해 로그인해 주세요.',
    loginHelpAccessTitle: '로그인 지원',
    loginHelpAccessDescription: '로그인이 되지 않거나 사용 권한 신청이 필요한 경우, 기업 위챗으로 孟宪秋에게 문의해 주세요.',
    homeAboutTitle: 'Design Sheet 소개',
    homeAboutGoalTitle: '프로젝트 목표',
    homeAboutDescription: 'Design Sheet는 스타일 자료, 원부자재, 패턴·사이즈와 테크팩을 한곳에 모아 디자인부터 생산 인계까지 담당자 간 협업을 지원합니다. 중복 입력을 줄이고 수정·확인 이력을 남깁니다.',
    homeAboutRoles: '상품기획, 디자이너, 원부자재 구매, 패턴사, 생산관리 및 디자인 실장의 협업을 지원합니다.',
    homeAboutProgressTitle: '현재 진행 상황',
    homeAboutProgressDescription: '현재 ND·EE 브랜드의 테스트 단계이며 자료 가져오기, 협업 입력, 디자인 승인, Tech Pack 미리보기와 내보내기를 지원합니다. 주문 시스템·SAP 데이터 연동은 검증 중이며 데이터 연결과 사용 흐름을 계속 개선할 예정입니다.',
    homeAboutFeedbackTitle: '의견 전달',
    homeAboutFeedbackDescription: '사용 중 문제나 개선 의견이 있으면 기업 위챗으로 孟宪秋에게 문의해 주세요. 관련 품번, 작업 내용이나 화면 캡처를 함께 보내 주세요.',
    esiLogin: '기업 위챗 QR 로그인',
    continueWecomLogin: '로그인 계속하기',
    openWecomLogin: '기업 위챗 로그인 페이지 열기',
    qrLoading: 'QR 코드를 불러오는 중…',
    qrUnavailable: 'QR 코드를 불러올 수 없습니다',
    esiNoAccess: '이 계정은 Design Sheet 사용 권한이 없습니다. 관리자에게 문의하세요',
    testAccountLogin: '테스트 계정 로그인',
    loginTitle: '로그인',
    loginSubtitle: '계정과 비밀번호를 입력하세요',
    username: '계정 / 사번',
    password: '비밀번호',
    usernamePlaceholder: '계정 또는 사번을 입력하세요',
    passwordPlaceholder: '비밀번호를 입력하세요',
    login: '로그인',
    logout: '로그아웃',
    logoutConfirm: '로그아웃 하시겠습니까?',
    loginSuccess: '로그인되었습니다',
    sessionKept:
      '서비스가 일시적으로 이용 불가합니다. 로그인 상태는 유지되어 있으니 복구 후 「다시 시도」를 누르세요. 비밀번호를 다시 입력할 필요는 없습니다.',
    retryRestore: '다시 시도',
    changePassword: '비밀번호 변경',
    currentPassword: '현재 비밀번호',
    newPassword: '새 비밀번호',
    confirmPassword: '새 비밀번호 확인',
    profile: '내 정보',
    department: '부서',
    roles: '역할',
  },

  nav: {
    integrations: "업무 연결",
    dashboard: '워크벤치',
    workbench: '내 할 일',
    sheet: '의뢰서',
    sheetList: '의뢰서 목록',
    legacySheets: '과거 의뢰서',
    sheetDetail: '의뢰서 상세',
    sheetCreate: '의뢰서 생성',
    sheetApproval: '의뢰서 승인',
    spec: '사양 입력',
    fabricWidth: '원단 폭',
    trimAttr: '부자재 정보',
    baseSize: '기준치수',
    materialUsage: '원자재 소요량',
    trimUsage: '부자재 소요량',
    sizeTolerance: '치수 편차',
    sap: 'SAP 전송',
    sapTransfer: '데이터 전송',
    sapLog: '전송 이력',
    permissions: '역할 권한',
    admin: '시스템 관리',
    userManage: '사용자 관리',
    costConfig: '환율·원가 파라미터',
    subMaterials: '부자재 라이브러리',
    business: '업무',
    system: '시스템',
    masterData: '기준정보',
    masterDicts: '기준 사전',
    roleManage: '역할·권한',
    about: '정보',
    auditLog: '감사 로그',
    sapTransfers: 'SAP 전송 이력',
  },

  role: {
    ADMIN: '시스템 관리자',
    APPROVER: '디자인 실장',
    DESIGNER: '디자이너',
    PRODUCTION: '생산관리',
    FABRIC: '원부자재 구매',
    PATTERN: '패턴사',
    PLANNER: '상품기획',
    VIEWER: '조회 전용',
  },

  perm: {
    mgrTitle: '사용자 권한 관리',
    mgrHint: '기본은 역할을 따르고, 개별 사용자에게 권한을 직접 지정하면 「커스텀」으로 표시됩니다. 저장 후 해당 사용자는 재로그인해야 적용됩니다.',
    searchUser: '사용자 검색',
    pickUser: '← 사용자를 선택하세요',
    custom: '커스텀',
    roleDefault: '현재 역할 기본 권한',
    resetToRole: '역할 기본으로 복원',
    revokeHint: '저장 시 해당 사용자의 로그인 상태가 해제됩니다(권한이 토큰에 있음). 사용 중인 창은 최대 2시간 후 자동 만료됩니다.',
    saved: '권한 저장됨',
    desc: '이 페이지는 시스템의 권한 정의에서 실시간으로 생성됩니다. 손으로 쓴 문서가 아니므로 규칙이 바뀌면 즉시 반영됩니다.',
    mine: '내 권한',
    myScopes: '현재 편집 가능한 모듈',
    noneEditable: '없음(이 역할은 의뢰서 입력에 참여하지 않습니다)',
    adminNote: '시스템 관리자는 모든 모듈이 허용되며 아래 표의 제한을 받지 않습니다.',

    matrixTitle: '누가 무엇을 편집할 수 있는가',
    matrixHint:
      '의뢰서는 아래의 「편집 영역」으로 나뉘며 각 영역마다 담당 역할이 정해져 있습니다. 역할은 병행으로 작업하며 서로를 막지 않습니다. 오른쪽에서 문서 상태를 바꾸면 상태별로 누가 잠기는지 볼 수 있습니다.',
    previewStatus: '이 상태로 보기',
    scope: '편집 영역',
    approvalBound: '디자인 승인의 영향을 받음',
    legendYes: '편집 가능',
    legendLocked: '담당이지만 현재 상태에서는 잠김',
    legendNo: '편집 불가(조회만)',

    stagesTitle: '단계 완료 표시는 누가 하는가',
    stagesHint:
      '같은 절의 여러 표시가 서로 다른 역할에 속할 수 있습니다 —— 원부자재 절의 세 표시는 각각 다른 사람이 누릅니다.',
    section: '절',
    stage: '완료 표시',
    owner: '담당 역할',
    adminOnly: '시스템 관리자만',

    approvalTitle: '디자인 승인 흐름',
    flowSubmit: '디자이너 요청',
    flowApprove: '디자인 실장 승인',
    flowReject: '디자인 실장 반려',
    flowResubmit: '디자이너 수정 후 재요청',
    ruleParallel:
      '디자이너가 담당하는 내용만 승인합니다. 다른 역할은 승인 상태와 무관하게 언제든 입력할 수 있습니다.',
    rulePendingLock: '승인 대기 중에는 디자인 내용이 잠깁니다 —— 심사 중인 내용은 바뀌면 안 됩니다.',
    ruleEditAfterApprove:
      '승인 후에도 수정할 수 있지만, 수정하면 승인이 무효가 되어 자동으로 임시저장으로 돌아가며 다시 요청해야 합니다(상태 이력에 기록됩니다).',
    ruleRejectMemo:
      '반려 시 사유는 필수이며 디자이너가 이를 보고 수정합니다. 반복 반려·재요청이 가능하고 매 회차가 기록됩니다.',
    ruleCancelled: '문서가 폐기되면 모든 모듈을 편집할 수 없습니다.',

    rolesTitle: '역할별 권한 포인트',
    rolesHint:
      '권한 포인트는 해당 API에 들어갈 수 있는지를, 위의 편집 영역은 들어간 뒤 어디를 고칠 수 있는지를 결정합니다. 둘 다 충족해야 합니다.',
    permissionCount: '개 권한 포인트',
    myRoleNote: '내 역할은 「{role}」이며 권한 포인트는 {n}개입니다.',

    source:
      '데이터 출처: 편집 영역은 공유 패키지 constants/edit-scopes.ts, 권한 포인트는 데이터베이스의 역할 설정입니다.',
  },

  editScope: {
    SOURCE_INFO: '스타일 원본 정보',
    ORDER_QUANTITY: '주문 수량 수정',
    PATTERN_INFO: '패턴 참조 정보',
    PRODUCTION_INFO: '완제품 공급업체',
    MANUAL_STYLE: '수동 스타일 컬러 및 사이즈',
    MANUAL_COMMERCE: '수동 스타일 판매가 및 수량',
    ORDER_INFO: '입고 요청일',
    DESIGN: '디자인',
    COLORWAY: 'ColorWay 배색',
    USP: 'USP·디자인 의도',
    FABRIC_BASE: '원단 정보',
    FABRIC_PROD: '원단 생산 항목',
    TRIM: '부자재 BOM',
    CONSUMPTION: '원단 요척',
    TRIM_CONSUMPTION: '부자재 요척',
    PRICE: '단가',
    COST: '원가 입력',
    TRIM_TECHNICAL: '부자재 기술자료',
    SIZE_DEVIATION: '치수 편차',
    SIZE_SPEC: '기준치수',
    QUANTITY: '발주 수량(읽기 전용)',
    ONLINE: '온라인 상품 정보',
    QC: 'QC 의뢰서',
    TECHPACK_EXPORT: 'Tech Pack 최종 확인',
  },

  editScopeWhere: {
    MANUAL_STYLE: '상품기획에서 수동 스타일의 컬러 및 사이즈를 관리하고 디자이너가 기준 사이즈를 선택합니다.',
    MANUAL_COMMERCE: '상품기획이 수동 스타일 판매가, 수량, 주문 정보 및 담당자를 관리합니다.',
    ORDER_INFO: '04절: 상품기획 또는 생산관리에서 입고 요청일을 수정합니다.',
    ORDER_QUANTITY: '상품기획에서 의뢰서의 색상별·사이즈별 주문 수량을 수정하며 원본과 수정 이력을 유지합니다.',
    PATTERN_INFO: '해당 스타일의 패턴사가 패턴 모듈 및 참조 의뢰서·스타일 번호를 관리합니다.',
    DESIGN: '01절: 도식화 / 메인정보 / 디자인 메모 / 상세 이미지',
    COLORWAY: '02절: ColorWay 배색표',
    USP: '08절: 핵심 셀링포인트와 디자인 의도',
    FABRIC_BASE: '02절 주자재: 사용부위 / 분류 / 코드 / 명칭 / 혼용률 / 후가공 / 공급처 / 적용 컬러',
    FABRIC_PROD: '02절 주자재: 원단 폭, 단위, 중량(메인 프로세스 7단계)',
    TRIM: '02절: 부자재 BOM의 구조와 속성',
    CONSUMPTION: '원단 요척은 패턴사가 입력',
    TRIM_CONSUMPTION: '부자재 요척은 디자이너가 입력하고 패턴사가 확인',
    PRICE: '02절: 주자재·부자재의 단가와 통화(원가 계산용)',
    COST: '02절 원가: 구매 방식, FOB 단가, 가공비, 외주 공정비, 통관비; 원가 스냅샷 확정',
    TRIM_TECHNICAL: '02절: 부자재 색상, 규격과 기술메모(패턴사)',
    SIZE_DEVIATION: '03절: 좌우 편차와 허용치(패턴사)',
    SIZE_SPEC: '03절: 기준치수, 사이즈별 값과 측정방법(패턴사)',
    QUANTITY: '04절: 이전 단계에서 확정된 발주 수량을 조회합니다.',
    ONLINE: '07절: 온라인 상품 정보',
    QC: '06절: QC 의뢰서 각 차수',
    TECHPACK_EXPORT: '05절: 생산 관리 최종 확인, 스타일 조회자는 내보내기 가능',
  },

  admin: {
    usersDesc:
      '한 사람당 하나의 역할입니다. 역할에 따라 의뢰서의 어느 모듈을 편집할 수 있는지 결정되며, 나머지는 조회만 가능합니다.',
    createUser: '사용자 등록',
    editUser: '사용자 수정',
    username: '계정 / 사번',
    usernameRequired: '계정을 입력하세요',
    usernamePattern: '계정은 영문, 숫자와 . _ - 만 사용할 수 있습니다',
    displayName: '이름',
    displayNameRequired: '이름을 입력하세요',
    role: '역할',
    roleRequired: '역할을 선택하세요',
    noRole: '미지정',
    department: '부서',
    email: '이메일',
    locale: '화면 언어',
    status: '상태',
    active: '사용',
    inactive: '중지',
    activate: '사용',
    deactivate: '중지',
    lastLogin: '최근 로그인',
    authProvider: '인증 방식',
    authLocal: '계정/비밀번호',
    authSso: '위챗워크',
    bound: '연동됨',
    searchPlaceholder: '계정 / 이름 / 이메일 검색',
    resetPassword: '비밀번호 재설정',
    resetPasswordConfirm:
      '{name} 의 비밀번호를 재설정할까요? 임시 비밀번호가 새로 발급되며 현재 로그인은 즉시 만료됩니다.',
    deactivateConfirm: '{name} 을(를) 중지할까요? 중지하면 즉시 로그인할 수 없습니다.',
    activateConfirm: '{name} 을(를) 다시 사용 상태로 바꿀까요?',
    cannotChangeOwnRole: '본인의 역할은 변경할 수 없습니다(스스로 잠기는 것을 방지)',
    brands: '조회 브랜드',
    allBrands: '전체 브랜드',
    noBrand: '미설정',
    brandsPlaceholder: '브랜드 선택(복수 선택 가능)',
    brandsHint: '업무 브랜드 권한을 개별 선택합니다. 미사용 브랜드의 기존 권한은 보관되지만 자료는 숨깁니다. 변경은 이후 접근 시 적용됩니다.',
    adminAllBrands: '관리자는 사용 중인 모든 브랜드의 업무를 조회하고 등록된 전체 브랜드를 관리합니다.',
    noBrandConfirm: '선택한 브랜드가 없어 이 사용자는 로그인해도 의뢰서를 하나도 볼 수 없습니다. 이대로 저장할까요?',
    tempPasswordHint: '등록하면 임시 비밀번호가 생성됩니다. 한 번만 표시되므로 복사해 본인에게 전달하세요.',
    tempPasswordTitle: '임시 비밀번호',
    tempPasswordWarn: '창을 닫으면 다시 볼 수 없습니다. 잊었다면 다시 재설정하세요.',
    copy: '복사',
    copied: '복사했습니다',
    copyFailed: '복사에 실패했습니다. 직접 선택해 주세요',
  },

  status: {
    DRAFT: '임시저장',
    PENDING: '승인 대기',
    APPROVED: '승인 완료',
    REJECTED: '반려',
    CANCELLED: '폐기',
  },

  server: {
    sapTransferInProgress: '이 스타일의 전송이 아직 끝나지 않았습니다. 처리 결과를 확인한 후 재전송 여부를 결정하세요.',
    sapProbeReadOnly: '연결 확인은 스타일 조회에만 사용됩니다. 의뢰서 전송은 해당 스타일에서 실행하세요.',
    qcRemoveAttachmentsFirst: '이번 회차의 첨부파일을 먼저 제거한 후 QC 회차를 삭제해 주세요.',
    qcRoundMissing: 'QC 회차가 더 이상 존재하지 않습니다. 의뢰서를 다시 열어 주세요.',
    qcRoundCompleted: '이번 QC 회차는 완료되었습니다. 완료를 취소한 후 수정해 주세요.',
    rowEditConflict: '이 표가 변경되었습니다. 입력 내용은 보관되어 있습니다. 의뢰서를 다시 열어 확인한 후 저장해 주세요.',
    rowUndoUnavailable: '이 삭제는 되돌릴 수 없습니다.',
    rowUndoExpired: '되돌리기 시간이 지났습니다. 다시 입력해 주세요.',

    scopeReadonly: '현재 계정은 이 부분을 조회할 수 있습니다. 해당 스타일 담당자가 수정하세요.',
    materialRowsChanged: '원단 행이 변경되었습니다. 새로고침 후 확인하여 저장하세요.',
    sizeRowsChanged: '치수 행이 변경되었습니다. 새로고침 후 확인하여 저장하세요.',
    stageDesignMissing: '디자인 도안과 기준 사이즈를 먼저 입력하세요.',
    stageDeviationMissing: '각 부위의 상·하 허용치를 입력하세요. 편차가 없으면 0을 입력하세요.',
    stageWidthMissing: '각 원단의 폭을 먼저 입력하세요.',
    stageTrimMissing: '부자재 코드와 적용 사이즈 규격을 확인하세요.',
    stageUsageMissing: '원단과 적용 부자재의 요척을 입력하세요. 사용량이 없으면 0을 입력하세요.',
    patternSizeEmpty: '측정부위와 치수 값이 있는 사이즈 자료를 먼저 저장한 후 완료를 확인하세요.',
    subMaterialRowsChanged: '부자재 행이 변경되었습니다. 새로고침하여 확인한 후 다시 저장하세요.',
    techpackNotReady: 'Tech Pack 자료 확인이 미완료입니다. 아래 작업을 먼저 완료하세요.',
    demoNoTransfer: '시연 자료는 업무 테스트용이며 SAP로 전송할 수 없습니다.',
    stageMismatch: '현재 섹션에 해당하는 확인 항목이 아닙니다. 페이지를 새로고침한 후 다시 시도하세요.',
    packNotConfirmed: '생산관리 담당자가 Tech Pack을 최종 확인해야 합니다.',
    testViewNoPassword: '테스트 사용자 관점에서는 계정 비밀번호를 변경할 수 없습니다.',
    assigneeOnlyDraft: '초안 또는 반려된 의뢰서에서 담당자를 변경할 수 있습니다.',
    assigneeMismatch: '해당 브랜드를 조회할 수 있고 역할이 일치하는 활성 계정을 선택하세요.',
    testViewClosed: '테스트 사용자 전환이 종료되었습니다. 관리자로 돌아가세요.',
    testViewBusinessOnly: '활성화된 업무 계정을 선택하세요.',
    roleNotFound: '역할이 존재하지 않습니다.',
    adminRoleProtected: '관리자 권한은 시스템에서 관리하며 여기서 변경할 수 없습니다.',
    unknownPermissions: '유효하지 않은 권한이 포함되어 있습니다. 새로고침 후 다시 시도하세요.',
    notSubmittable: '현재 상태에서는 승인 요청할 수 없습니다(초안 또는 반려 상태만 가능)',
    nothingToWithdraw: '승인 대기 중인 요청이 없어 철회할 수 없습니다',
    nothingToDecide: '결정 대기 중인 디자인 내용이 없습니다',
    rejectMemoRequired: '반려 시 의견은 필수입니다',
    badCredentials: '계정 또는 비밀번호가 올바르지 않습니다',
    accountDisabled: '정지된 계정입니다. 관리자에게 문의하세요',
    esiSessionExpired: 'AI Lab 로그인 세션이 만료되었습니다. 다시 로그인해 주세요',
    esiAccountNotConfigured: 'Design Sheet 이용 권한이 없습니다. 관리자에게 문의하세요',
    esiPasswordManaged: 'AI Lab 로그인 계정은 로컬 비밀번호를 설정하지 않습니다',
    sapResultNeedsCheck: '이전 전송 결과가 확인되지 않았습니다. SAP 기록을 확인한 후 진행해 주세요',
    userNotFound: '사용자가 존재하지 않습니다',
    wrongPassword: '현재 비밀번호가 올바르지 않습니다',
  },
  submitCheck: {
    noFlatSketch: '「디자인」 섹션에 도면이 없습니다',
    noStdSize: '「디자인」 섹션에 기준 사이즈가 없습니다',
    noColorway: '「원부자재」 섹션의 ColorWay에 사용 중인 컬러가 1개 이상 필요합니다',
    stageNotDone: '「{section}」 섹션의 「{stage}」 완료 표시가 되어 있지 않습니다',
  },
  hero: {
    createTitle: '의뢰서 생성',
    createDesc: '오더페어 결과 또는 추가주문 결과로 새 스타일을 시작하세요. 기존 스타일 검색도 가능합니다.',
    fromOrderFair: '오더페어에서 생성',
    fromReorder: '추가주문에서 생성',
    reorderHint: '추가주문 인터페이스 연결 후 오픈 예정(준비 중)',
    moreWays: '다른 방법',
  },
  pipe: {
    toCreateHint: '최신 오더페어에서 아직 의뢰서를 만들지 않은 스타일입니다. 오더페어 목록에서 선택해 시작하세요.',
    title: '내 스타일 파이프라인',
    desc: '생성부터 공장 발송까지, 한 스타일이 지나가는 5단계입니다. 숫자를 누르면 해당 목록으로 이동합니다.',
    pendingApproval: '승인 대기(제출됨)',
    approved: '승인 완료',
    techpackSent: 'Tech Pack 확인 완료',
  },
  audit: {
    title: '감사 로그',
    desc: '시스템의 모든 쓰기 작업 기록 — 누가, 언제, 무엇을. 행을 클릭하면 변경 전후를 비교합니다.',
    keywordPh: '작업 / 대상 id 검색',
    targetType: '대상 유형',
    action: '작업',
    actor: '작업자',
    from: '시작 시각',
    to: '종료 시각',
    time: '시각',
    what: '작업 내용',
    target: '대상',
    detail: '상세',
    before: '변경 전',
    after: '변경 후',
    scopes: {
      sheet: '문서 전체', material: '원부자재', design: '디자인', pattern: '패턴·치수',
      qc: 'QC', usp: 'USP', online: '온라인 상품', cost: '원가', techpack: 'TechPack',
    },
  },
  sap: {
    transfer: 'SAP 전송',
    transferConfirm: '의뢰서 {modelCd}를 SAP(CE2)에 전송해 D-BOM을 생성할까요? 전송 내용과 로그가 보관됩니다.',
    transferTitle: 'SAP로 전송',
    transferOk: 'SAP 전송 완료(「SAP 전송 상태」 페이지 참조)',
  },
  switch: {
    account: '테스트 계정 전환(브랜드×역할)',
    roleOnly: '역할만 전환',
    reset: '본인으로 복원',
  },
  about: {
    title: 'Design Sheet 정보',
    desc: '소프트웨어 버전 정보와 릴리스 번호 규칙입니다.',
    version: '소프트웨어 버전',
    stage: '릴리스 단계',
    devStage: '개발 중',
    testStage: '테스트 버전',
    buildTime: '빌드 시각',
    noteSeparate: '소프트웨어 버전은 앱 릴리스를 식별합니다. 의뢰서 단계는 평가회·수주회·본 생산을 기록하며 숫자 기록 버전 및 QC 차수와 별도로 관리합니다.',
    versionLine: '문의 시 아래 버전 정보를 첨부해 주세요:',
    rulesTitle: '버전 번호 규칙',
    colNo: '번호',
    colWhen: '적용 시점',
    rulePatch: '문제 수정·패치 번호 증가',
    ruleMinor: '호환 기능 추가·마이너 번호 증가',
    ruleMajor: '정식 릴리스 버전',
    ruleRc: '정식 릴리스 전 후보 버전',
    rulesNote: '버전 번호의 유일한 출처는 프로젝트 루트 package.json이며 빌드 흐름에서 주입됩니다. 이 페이지는 읽기 전용입니다.',
  },
  board: {
    pendingTasks: '처리할 업무',
    allTasks: '전체 업무',
    pageGroupCount: '현재 페이지{count}건',

    searchPh: '스타일 / 의뢰서 번호 / 품명 검색',
    title: '상품 보드',
    group: { none: '그룹 없음', progress: '완료도별', season: '연도·시즌별', source: '출처별' },
    viewCard: '카드',
    viewList: '목록',
    viewAll: '전체 보기',
    done: '완료',
    ongoing: '진행 중',
    cancelled: '폐기',
    unclassified: '미분류',
    continue: '계속 작성',
    view: '보기',
    emptyTitle: '아직 상품이 없습니다',
    noImage: '이미지 없음',
    field: { brand: '브랜드', season: '시즌', source: '출처' },
    progress: '진행률',
    empty: '의뢰서가 없습니다 — 「의뢰서 목록」에서 생성하세요',
  },
  source: {
    ORDER_FAIR: '대량 · 오더페어',
    MANUAL: '수동 생성',
    REORDER: '추가주문 · 자사 분석 제안',
  },
  devSwitch: {
    label: '테스트 · 역할 전환',
    restore: '본인으로 복원',
  },
  error: {
    VALIDATION_FAILED: '입력 내용에 오류가 있습니다. 확인 후 다시 시도하세요',
    UNAUTHORIZED: '로그인이 만료되었습니다. 다시 로그인하세요',
    TOKEN_EXPIRED: '로그인이 만료되었습니다. 다시 로그인하세요',
    FORBIDDEN: '해당 작업을 수행할 권한이 없습니다',
    NOT_FOUND: '요청한 데이터가 존재하지 않습니다',
    CONFLICT: '데이터 충돌이 발생했습니다. 새로고침 후 다시 시도하세요',
    INVALID_STATE: '현재 문서 상태에서는 해당 작업을 수행할 수 없습니다',
    RATE_LIMITED: '요청이 너무 잦습니다. 잠시 후 다시 시도하세요',
    SAP_ERROR: 'SAP 인터페이스 오류입니다. 관리자에게 문의하세요',
    SERVICE_UNAVAILABLE: '서비스를 일시적으로 이용할 수 없습니다(데이터베이스 연결 오류). 잠시 후 다시 시도하세요',
    INTERNAL_ERROR: '서버 오류입니다. 잠시 후 다시 시도하세요',
    NETWORK: '네트워크 연결에 실패했습니다. 네트워크를 확인하세요',
    UNKNOWN: '알 수 없는 오류가 발생했습니다',
    requestId: '오류 추적번호',
  },

  page: {
    todo: {
      title: '내 할 일',
      desc: '현재 처리가 필요한 사항 요약입니다. 카드를 클릭하면 해당 문서로 이동합니다. 0은 대기 중인 항목이 없음을 의미합니다.',
      toCreate: '생성 대기(신규)',
      todoDrafting: '작성 중(초안)',
      pendingApproval:'승인 대기',
      rejected: '반려되어 수정 필요',
      missingPrice: '단가 미입력 행 있음',
      missingUsage: '소모량 미입력 행 있음',
      technicalPending: '기술 자료 완료 대기',
      approvedNotTransferred: '승인됨, SAP 미전송',
      go: '보기',
    },
    dashboard: {
      title: '워크벤치',
      eyebrow: 'WORKBENCH',
      welcome: '{name}님, 환영합니다',
      scopeTitle: '이번 버전의 재구축 범위',
      scopeDesc: '이번 버전은 메인 프로세스 5~13단계를 다루며, 나머지 단계는 SAP에서 계속 운영됩니다.',
      inScope: '이번 범위',
      outOfScope: '해당 없음',
    },
    notFound: {
      title: '페이지를 찾을 수 없습니다',
      desc: '요청한 페이지가 존재하지 않거나 삭제되었습니다.',
      back: '워크벤치로 이동',
    },
    forbidden: {
      title: '접근 권한이 없습니다',
      desc: '이 페이지에 접근할 권한이 없습니다. 필요한 경우 시스템 관리자에게 문의하세요.',
      back: '워크벤치로 이동',
    },
  },

  integration: {
    pageHint: "EADS ↔ SAP PI 인터페이스 연결 상태. 테스트는 수동이며 실제로 SAP를 한 번 호출합니다. 인증 실패는 계정 보호에 누적됩니다.",

    tunnelTitle: 'SSH 점프 서버',
    tunnelHint: '방화벽 때문에 내부망 엔드포인트에 직접 연결할 수 없어 점프 서버를 경유합니다(ssh -L과 동일). 업무 로직은 그대로이며 경로만 달라집니다',
    tunnelConnected: '연결됨, 로컬 포워딩 포트 {port}',
    tunnelIdle: '미연결 — 다음 호출 시 자동으로 연결됩니다',
    tunnelNotConfigured: '설정 부족: 호스트·사용자와 비밀번호(또는 개인키)가 필요합니다',
    tunnelNoFingerprint: '호스트 지문이 설정되지 않아 SSH 호스트 검증을 건너뜁니다 — 중간자 공격을 탐지할 수 없습니다. ssh-keyscan으로 지문을 확인해 .env에 넣으세요',
    tunnelReconnect: '점프 서버 재연결',
    tunnelReconnected: '연결을 끊었습니다. 다음 호출 시 다시 연결됩니다',
    step: {
      'jump-tcp': '① 본 PC → 점프 서버',
      'ssh-auth': '② SSH 로그인',
      forward: '③ 점프 서버 → 내부망 엔드포인트',
      http: '④ 엔드포인트 HTTP 응답 여부',
      config: '설정 확인',
    },
    reachTitle: "네트워크 연결",
    reachHint: "TCP 핸드셰이크만 수행하며 계정 정보를 보내지 않습니다. 문제 확인은 여기부터 —— 네트워크가 안 되면 비밀번호가 맞아도 인증 자체가 일어나지 않으므로 잠금 횟수에도 포함되지 않습니다.",
    reachRun: "연결 확인",
    enabled: "전체 스위치",
    on: "켜짐",
    off: "꺼짐",
    credentials: "인터페이스 계정",
    configured: "설정됨",
    missing: "미설정",
    sysGbn: "시스템 구분",
    endpoint: "엔드포인트",
    circuitClosed: "계정 보호 정상",
    circuitOpen: "계정 보호 차단됨",
    circuitDesc: "인증 연속 실패 {failures} / {limit}회, 로컬에서 {remaining}회 남았습니다. SAP 측은 연속 3회면 계정이 잠깁니다.",
    reset: "복구",
    resetConfirmTitle: "계정 보호 복구",
    resetConfirm: "복구 전에 인터페이스 계정 비밀번호가 정확한지 확인하세요. 비밀번호가 틀린 상태로 계속 호출하면 SAP 측 실패 횟수가 3회에 도달해 계정이 잠깁니다. 계속할까요?",
    resetConfirmOk: "확인했습니다, 복구",
    resetDone: "복구되었습니다",
    id: "인터페이스 번호",
    interfaceName: "Interface 명",
    description: "설명",
    usedBy: "사용처",
    lastProbe: "최근 테스트",
    notProbed: "미테스트",
    probe: "연결 테스트",
    probeStyleCd: "테스트용 스타일번호",
    probeStyleCdPlaceholder: "비우면 기본값 사용",
    probeStyleCdHint: '카탈로그에서 「연결 테스트」 시 사용할 스타일 코드. 비우면 서버 기본값을 사용합니다',

    catalogTitle: '인터페이스 카탈로그',
    catalogHint: '백엔드 팀 인터페이스 목록의 전체 버전으로, 문서처럼 조회할 수 있습니다. 검색은 필드명까지 포함합니다',
    catalogCounts: '전체 {total}개 · 당사 호출 가능 {callable}개 · 구현 완료 {implemented}개 · 현재 표시 {shown}개',
    catalogSearchPh: '인터페이스 번호 / 이름 / 설명 / 필드명 검색',
    catalogNoMatch: '일치하는 인터페이스가 없습니다',
    dirAll: '전체',
    dirOut: 'EADS → SAP',
    dirIn: 'SAP → EADS',
    dirOutShort: '당사 호출',
    dirInShort: 'SAP 전송',
    onlyInUse: '사용 중만',
    onlyImplemented: '구현 완료만',
    noSummary: '(인터페이스 목록에 설명이 없습니다)',
    noFields: '인터페이스 정의서에 이 인터페이스의 필드표가 없습니다',
    tagAsync: '비동기',
    tagUnused: '미사용',
    stage: {
      done: '구현 완료',
      registered: '등록됨',
      none: '미연동',
    },
    metaProgram: 'SAP 프로그램',
    metaTransport: '전송 방식',
    metaCycle: '호출 주기',
    metaNs: '네임스페이스',
    metaAdapter: '어댑터',
    metaOwner: '백엔드 담당',
    metaNote: '비고',
    fField: '필드',
    fDesc: '설명',
    fType: '타입',
    fLen: '길이',
    fSample: '예시',
    fTable: '내부 테이블',
    probeConfirmTitle: "인터페이스 연결 테스트",
    probeConfirm: "{id}을(를) 실제로 한 번 호출합니다. 인증 실패 시 계정 보호에 누적되며 로컬에서 {n}회 남습니다. SAP 측은 연속 3회면 계정이 잠깁니다. 진행할까요?",
    probeConfirmOk: "진행"
  },
  sapSpot: {
    wired: '연동됨',
    notWired: '미연동',
  },

  integrationResult: {
    "OK": "연결됨",
    "BUSINESS_ERROR": "업무 오류",
    "AUTH_FAILED": "인증 실패",
    "UNREACHABLE": "네트워크 불가",
    "BAD_RESPONSE": "응답 이상",
    "NOT_CONFIGURED": "미설정",
    "CIRCUIT_OPEN": "보호 차단",
    "UNKNOWN": "알 수 없음"
  },
  legacy: {
    eyebrow: '구시스템 EADS',
    listTitle: '과거 의뢰서',
    listDesc: '구시스템에서 이전된 과거 데이터(2019년~), 읽기 전용',
    detailDesc: '구시스템 과거 데이터, 읽기 전용',
    keywordPlaceholder: '품번 / 스타일번호 / 스타일명',
    brand: '브랜드',
    year: '년도',
    state: '상태',
    stateCol: '상태',
    modelCd: '의뢰서 품번',
    styleCd: '스타일번호',
    styleNm: '스타일명',
    yearSeason: '년도 / 시즌',
    designer: '디자이너',
    colors: '컬러',
    trims: '부자재',
    createdAt: '등록일',
    empty: '데이터 없음',
    colorways: '컬러웨이',
    tagColor: '택 컬러',
    washing: '세탁 정보',
    materials: '원단',
    usedPart: '사용부위',
    materialId: '원단 번호',
    materialNm: '원단명',
    yardage: '소요량',
    width: '유폭',
    unit: '단위',
    unitPrice: '단가',
    ingredient: '혼용률',
    trimsSection: '부자재 BOM',
    trimCode: '부자재 코드',
    trimName: '부자재명',
    trimType: '종류',
    colorMatchPart: '배색부위',
    consumption: '소요량 상세',
    memo: '메모',
    stdSizes: '기준 사이즈',
    patternPart: '부위',
    size: '사이즈',
    tolerance: '공차',
    measurement: '측정 방법',
    progress: '진행 이력',
    statusDate: '일자',
    comment: '내용',
    modiHistory: '수정 이력',
    modiTime: '일시',
    amendTable: '테이블',
    amendField: '필드',
    beforeAfter: '변경 전 → 후',
    designMemos: '디자인 메모',
    salePrice: '판매가',
    chargePattern: '패턴 담당',
    chargePurchase: '구매 담당',
    chargeProduction: '생산 담당',
  },

  dict: {
    eyebrow: '기준정보',
    title: '기준 사전',
    desc: '상품 컬러(브랜드별), 사이즈-분류 매핑, 원자재 컬러. 참조 파일에서 최초 가져온 뒤 화면에서 관리',
    brandColor: '상품 컬러',
    sizeCategory: '사이즈 분류',
    materialColor: '원자재 컬러',
    keywordPlaceholder: '코드 / 명칭 검색',
    brand: '브랜드',
    colorCd: '컬러 코드',
    colorNm: '영문명',
    nameZh: '중문명',
    nameKo: '한국어명',
    used: '사용',
    cate1: '대분류 코드',
    cate1Name: '대분류 명칭',
    cate1NameZh: '대분류 중문명',
    cate1NameKo: '대분류 한국어명',
    cate1Placeholder: '대분류 없으면 비움',
    sizeCd: '사이즈 코드',
    segment: '사이즈 구분',
    segmentZh: '사이즈 구분(중문)',
    segmentKo: '사이즈 구분(한국어)',
    brands: '적용 브랜드',
    family: '컬러 계열',
    colorName: '컬러명',
    add: '추가',
    addTitle: '사전 항목 추가',
    editTitle: '사전 항목 편집',
    deleteConfirm: '이 사전 항목을 삭제하시겠습니까? 이미 입력된 의뢰서의 기존 값은 유지되며, 목록에서만 사라집니다.',
  },
  sapTransfer: {
    states: { SUCCESS: '전송 완료', FAILED: '전송 실패', SENDING: '전송 중', PENDING: '전송 대기', RECONCILE: '결과 확인 필요' },
    empty: '전송 기록이 없습니다 —— 승인된 의뢰서를 SAP로 전송하면 여기에 표시됩니다.',
    title: 'SAP 전송 이력',
    desc: '의뢰서를 SAP(SP0070)에 전송한 기록입니다. 실패한 건은 수동 재전송할 수 있습니다',
    refresh: '새로고침',
    allStatus: '전체 상태',
    time: '시작 시각',
    sheet: '의뢰서',
    channel: '채널',
    status: '상태',
    error: '실패 사유',
    by: '작업자',
    actions: '작업',
    resend: '재전송',
    resendTitle: 'SAP 전송 재시도',
    resendConfirm: '의뢰서 {model}을(를) 다시 전송할까요? 최신 내용으로 사전 검사부터 전체를 다시 진행합니다.',
    resendOk: '재전송 성공',
  },

};
